ThemeJS.Accordions = ( function ( $ ) {

  function set_item_open ( $item, opening ) {
    let $toggle = $( '.accordion-toggle', $item ).first();
    $toggle.attr( 'aria-expanded', opening ? 'true' : 'false' );
    $( '.accordion-content', $item )[ opening ? 'slideDown' : 'slideUp' ]( 300 );
    $item.toggleClass( 'open', opening );
  }

  function init () {
    $( '.accordion-group:not(.initialized)' ).each( function () {
      let $group = $(this);

      $group.on( 'click', '.accordion-item', function ( e ) {
        if ( $( e.target ).closest( '.accordion-content' ).length ) {
          return;
        }

        let $item = $(this);
        let opening = !$item.hasClass( 'open' );
        set_item_open( $item, opening );
      });

      $( '.accordion-item', $group ).each( function () {
        $( '.accordion-content', this ).css( 'display', $(this).hasClass( 'open' ) ? 'block' : 'none' );
      });

      $group.addClass( 'initialized' );
    });
  }

  $( init );

  return {
    init
  }

})( jQuery );
